import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/Loading";
import { AppLayout } from "@/pages/AppLayout";
import Login from "@/pages/Login";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import OwnerJobs from "@/pages/owner/OwnerJobs";
import CreateJob from "@/pages/owner/CreateJob";
import OwnerReports from "@/pages/owner/OwnerReports";
import OwnerSettings from "@/pages/owner/OwnerSettings";
import ManagerManagement from "@/pages/owner/ManagerManagement";
import AuditLog from "@/pages/owner/AuditLog";
import ManagerHome from "@/pages/manager/ManagerHome";
import ManagerJobs from "@/pages/manager/ManagerJobs";
import ManagerReports from "@/pages/manager/ManagerReports";
import Profile from "@/pages/manager/Profile";
import JobDetail from "@/pages/JobDetail";

function Protected({ role, children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen bg-[#FAF8F5]"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "OWNER" ? "/owner" : "/manager"} replace />;
  return children;
}

function Root() {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen bg-[#FAF8F5]"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "OWNER" ? "/owner" : "/manager"} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />

            {/* Owner full-screen routes */}
            <Route path="/owner/create" element={<Protected role="OWNER"><CreateJob /></Protected>} />
            <Route path="/owner/jobs/:id" element={<Protected role="OWNER"><JobDetail /></Protected>} />
            <Route path="/owner/audit" element={<Protected role="OWNER"><AuditLog /></Protected>} />
            <Route path="/owner/managers" element={<Protected role="OWNER"><ManagerManagement /></Protected>} />

            {/* Owner tabbed */}
            <Route path="/owner" element={<Protected role="OWNER"><AppLayout role="OWNER" /></Protected>}>
              <Route index element={<OwnerDashboard />} />
              <Route path="jobs" element={<OwnerJobs />} />
              <Route path="reports" element={<OwnerReports />} />
              <Route path="settings" element={<OwnerSettings />} />
            </Route>

            {/* Manager full-screen routes */}
            <Route path="/manager/jobs/:id" element={<Protected role="MANAGER"><JobDetail /></Protected>} />

            {/* Manager tabbed */}
            <Route path="/manager" element={<Protected role="MANAGER"><AppLayout role="MANAGER" /></Protected>}>
              <Route index element={<ManagerHome />} />
              <Route path="jobs" element={<ManagerJobs />} />
              <Route path="reports" element={<ManagerReports />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
